import { FaSpinner } from "react-icons/fa";
import styled, { keyframes, Keyframes } from "styled-components";

export function SpinnerCajas() {
  return <StyledSpinner />;
}

const spinnerAnimation: Keyframes = keyframes`
     0% { transform: rotate(0deg);}
     100% { transform: rotate(359deg);}

`;

const StyledSpinner = styled(FaSpinner)`
  height: 25px;
  width: 25px;
  margin: auto;
  animation: ${spinnerAnimation} 2s infinite linear;
`;
